import * as React from "react";
import "./reconciliationModal.scss"
import DateUtils from "../../../../../utils/DateUtils";
import CurrencyHelper from "../../../../../helper/CurrencyHelper";
import InvoicePaymentSummary from "../../../../../model/invoice/InvoicePaymentSummary";
import Routes from "../../../../../navigation/route/Route";
import LinkPresenter from "../../../../accounting/LinkPresenter";
import InvoiceSummary from "../../../../../model/invoice/InvoiceSummary";

interface IProps {
	invoice: InvoiceSummary | InvoicePaymentSummary;
	showUndoReconciliation: boolean
	onUndoReconciliationClick: () => void;
}

export const InvoiceInfo: React.SFC<IProps> = (props) => {
	const due = props.invoice instanceof InvoicePaymentSummary ? props.invoice.paymentAmount : props.invoice.due;
	return <>
		<div className="c-reconciliation-modal_payment-container_details-container">
			<div>
				<span>Invoice #</span>
				<span>To</span>
				<span>Amount due</span>
				<span>Reference</span>
				<span>Invoice date</span>
			</div>
			<div className="c-reconciliation-modal_payment-container_details-container_values-container invoice-details">
				<span>{props.invoice.invoiceNo.orNull}</span>
				<span>{props.invoice.customerDisplayName}</span>
				<span>{CurrencyHelper.toCurrency(due)}</span>
				<span>
						<LinkPresenter label={props.invoice.referenceNumber}
									   url={Routes.InvoiceDetailsView(props.invoice.referenceNumber)}/>
				</span>
				<span>{props.invoice.invoiceDate.format(DateUtils.DAILY_PLAN_DATE_FORMAT)}</span>
			</div>
		</div>
		{props.showUndoReconciliation &&
		<div className="c-reconciliation-modal_undo-link invoice-info" onClick={props.onUndoReconciliationClick}>
			Undo reconciliation
		</div>}
	</>
};
